module.exports = __webpack_public_path__ + "img/symbol_1.68ebab98.png";